import { isHttpMethod } from "@scalar/helpers/http/is-http-method";
import { objectKeys } from "@scalar/helpers/object/object-keys";
import { escapeJsonPointer } from "@scalar/openapi-parser";
import { getResolvedRef } from "../../helpers/get-resolved-ref.js";
import { getTag } from "./get-tag.js";
const createOperationEntry = (ref, operation, method, path = "Unknown", tag, titlesMap, getOperationId) => {
  const id = getOperationId({ ...operation, method, path }, tag);
  const title = operation.summary?.trim() ? operation.summary : path;
  titlesMap.set(id, title);
  return {
    id,
    title,
    path,
    method,
    ref,
    type: "operation"
  };
};
const traversePaths = (content, tagsMap, titlesMap, getOperationId) => {
  Object.entries(content.paths ?? {}).forEach(([path, pathItemObject]) => {
    const pathKeys = objectKeys(pathItemObject ?? {}).filter((key) => isHttpMethod(key));
    pathKeys.forEach((method) => {
      const _operation = pathItemObject?.[method];
      const operation = getResolvedRef(_operation);
      if (!operation) {
        return;
      }
      if (operation["x-internal"] || operation["x-scalar-ignore"] || !isHttpMethod(method)) {
        return;
      }
      const ref = `#/paths/${escapeJsonPointer(path)}/${method}`;
      if (operation.tags?.length) {
        operation.tags.forEach((tagName) => {
          const { tag } = getTag(tagsMap, tagName);
          tagsMap.get(tagName)?.entries.push(createOperationEntry(ref, operation, method, path, tag, titlesMap, getOperationId));
        });
      } else {
        const { tag } = getTag(tagsMap, "default");
        tagsMap.get("default")?.entries.push(createOperationEntry(ref, operation, method, path, tag, titlesMap, getOperationId));
      }
    });
  });
};
export {
  traversePaths
};
//# sourceMappingURL=traverse-paths.js.map
